import axios from 'axios';
import * as apiURL from './apiConfig';
import qs from 'qs';

export const getReviews = async (params) => {
  const { current, pageSize = 4, total, ...rest } = params;
  const newParams = {
    ...rest,
    skip: (current - 1) * pageSize,
    limit: pageSize,
  };

  try {
    const response = await axios.get(apiURL.REVIEW_URL, {
      params: newParams,
      paramsSerializer: (data) => {
        return qs.stringify(data, {
          arrayFormat: 'repeat',
          plainObjects: true,
        });
      },
    });
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const postReviews = async (data) => {
  try {
    const response = await axios.post(apiURL.REVIEW_URL, {
      ...data,
    });
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getReviewDetail = async (reviewId) => {
  try {
    const response = await axios.get(`${apiURL.REVIEW_URL}/${reviewId}`);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const editReview = async ({ formData, reviewId }) => {
  try {
    const response = await axios.put(
      `${apiURL.REVIEW_URL}/${reviewId}`,
      formData
    );
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
